/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HolderLastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function HolderLastName({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderCaptureMethod/Content/ExtraFields/Bluefin/Ach/HolderLastName",
  onChange,
  isInvalid,
  isSubmitting
  
}) {
let paymentBankAccountHolderLastNameValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'bank_account.holder_last_name',
})
let paymentBankAccountHolderLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'payment',
path: 'bank_account.holder_last_name',
validate: fromValidate.name,
required: true,
})
let paymentBankAccountHolderLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'payment',
path: 'bank_account.holder_last_name',
})
let paymentBankAccountHolderLastNameIsSubmittingData = fromData.useDataIsSubmitting({ viewPath,
context: 'payment',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="payment.bank_account.holder_last_name"
 validate="/Data/validate.js name"
 required={true}
 value={paymentBankAccountHolderLastNameValueData}
 onChange={paymentBankAccountHolderLastNameChangeData}
 invalid={!paymentBankAccountHolderLastNameIsValidData}
 invalidMessage="Please input account holder's last name"
 disabled={paymentBankAccountHolderLastNameIsSubmittingData}
 marginTop={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 placeholder="Account holder's last name"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}